import { createSlice } from "@reduxjs/toolkit";

export const LearningPathAuthoringSlice = createSlice({
  name: "LearningPathAuthoringSlice",
  initialState: {
    data: {} as any,
    formData: {} as any,
    isRearranging: false
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    updateSectionList(state, action) {
      state.data.sectionList = action.payload;
    },
    setForm(state, action) {
      state.formData = action.payload;
    },
    setIsRearranging(state) {
      state.isRearranging = true;
    },
    resetIsRearranging(state) {
      state.isRearranging = false;
    }
  }
});

export default LearningPathAuthoringSlice;
export const LearningPathAuthoringSliceActions =
  LearningPathAuthoringSlice.actions;
